import Filter from "./Filter";
import FormData from "./FormData";
import ListData from "./ListData";
import TableData from "./TableData";

const otpsComponents = {
  Filter,
  FormData,
  ListData,
  TableData
}

export default otpsComponents